import {
    registerSettingsAuthProvider,
} from 'one-ts-config';
import {
    clearAccessToken,
    getAccessToken,
    getAuthorizationHeader,
    isAuthApiEnabled,
    prefetchAccessToken,
} from './tokenService';

export * from './types';
export {
    clearAccessToken,
    getAccessToken,
    getAuthorizationHeader,
    isAuthApiEnabled,
    prefetchAccessToken,
};

export const registerSettingsAuth = (): void => {
    registerSettingsAuthProvider({
        isEnabled: isAuthApiEnabled,
        getAuthorizationHeader,
        prefetchAccessToken,
        clearAccessToken,
    });
};

registerSettingsAuth();
